import vmClient from 'app/services/vmClient';
import pick from 'lodash/pick';
import { Entity, IEntity, IEntityType } from '../../types/entity';
import {
  IUser,
  userAttributes,
  userAssociations,
} from './User';

export interface ILessonStudent extends IEntity {
  attributes: Pick<IUser['attributes'], 'id' | 'skypeId' | 'displayName'> & {
    deleted: boolean;
  };
  associations: Pick<IUser['associations'], 'brand'>;
}

export type LessonStudent = Entity<ILessonStudent>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonStudent: IEntityType<ILessonStudent> = vmClient.defineClass({
  typeName: 'LessonStudent',
  version: 3,
  persisted: true,

  attributes: {
    ...pick(userAttributes, ['skypeId', 'displayName']),

    deleted: 'boolean',
  },
  associations: {
    ...pick(userAssociations, ['brand']),
  },
});
